// Copyright (c) 2016 Deere & Company

export const isClaimTypStatusValid = selectedClaimTypes => selectedClaimTypes.length > 0;

export const isDBSFormValid = userDBSSettings =>
    isClaimTypStatusValid(userDBSSettings.claimTypes.selectedClaimTypes);



// WEBPACK FOOTER //
// ./src/user/dbs-settings/services/form-validation.js